import { render, staticRenderFns } from "./AddQuestionsToMatchDialog.vue?vue&type=template&id=315fec78"
import script from "./AddQuestionsToMatchDialog.vue?vue&type=script&lang=js"
export * from "./AddQuestionsToMatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports